import React, { useContext, useState } from 'react'
import { BackButton } from '../utils/Elements'
import InvoiceStatusHelper from '../helpers/InvoiceStatusHelper'
import InvoiceStatus from './InvoiceStatus'
import Context from '../context/Context'
import SwishForm from './SwishForm'
import { Formik } from 'formik'
import * as Yup from 'yup'
import SwishPending from './SwishPending'
import CellPhoneValidationApi from '../services/api/CellPhoneValidation'

const Swish = () => {
  const context = useContext(Context)
  const [formValues, setFormValues] = useState({})
  const [isFormDataValid, setIsFormDataValid] = useState(false)

  function validateCellPhone (values, actions) {
    const cellPhoneValidationApi = new CellPhoneValidationApi()
    cellPhoneValidationApi.post(
      context.customer.id,
      values.cellPhone
    )
      .then(res => res.json())
      .then(data => {
        if (data.short_code === '400') {
          actions.setErrors({ msg: data.message })
          setIsFormDataValid(false)
          actions.setSubmitting(false)
        } else {
          if (data.isValid === '1') {
            setIsFormDataValid(true)
            setFormValues(values)
            actions.setSubmitting(true)
          } else {
            setIsFormDataValid(false)
            actions.setSubmitting(false)
          }
        }
      })
      .catch(error => {
        actions.setErrors({ msg: error.toString() })
      })
  }

  if (isFormDataValid) {
    return <SwishPending cellPhone={formValues.cellPhone} />
  } else {
    if (InvoiceStatusHelper.shouldInvoiceBePaid(context.invoice)) {
      const CellPhoneSchema = Yup.object().shape({
        cellPhone: Yup.string()
          .trim()
          .required('Mobilnummer måste anges')
          .matches(/^[0-9]*$/, 'Endast siffror är tillåtna')
          .min(10, 'Mobilnumret ska innehålla 10 siffror')
          .max(10, 'Mobilnumret ska innehålla 10 siffror')
      })
      return (
        <div>
          <div className="row mt-5">
            <div className="col-12 text-center">
              <img src="/images/swish.png" className="img-fluid" alt="" />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center">
              <Formik
                initialValues={{
                  cellPhone: context.customer.cell_phone
                }}
                validationSchema={CellPhoneSchema}
                onSubmit={(values, actions) => { validateCellPhone(values, actions) }}>
                {(errors, isSubmitting) => (
                  <SwishForm errors={errors} isSubmitting={isSubmitting} />
                )}
              </Formik>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12 text-center">
              <BackButton style={context.style} />
            </div>
          </div>
        </div>
      )
    } else {
      return <InvoiceStatus />
    }
  }
}

export default Swish
